import { t } from "@/i18n-js/instance";
import {
  buildChatPromptMessage,
  buildQuestionPrompt,
  buildQuestionSelectorMessage,
} from "./messageFactory";

export const processHandler = ({
  history,
  addMessage,
  setIsUserInputEnabled,
  setConversationType,
  setProductArea,
  conversationType,
  productArea,
  createChatMessage,
  sessionId,
  setSessionId,
  setIsConversationEnded,
}) => {
  const processSelectConversationType = value => {
    if (value === "bug") {
      addMessage("bot", {
        content: t("support_widget.chatbot.templates.reach_out_to_support"),
        buttons: [
          {
            label: t("support_widget.send_a_message"),
            event: "contact-support",
            value: null,
          },
        ],
      });
    } else if (value == "question") {
      addMessage("bot", buildQuestionSelectorMessage());
    }
    setConversationType(value);
  };

  const processPostMessage = value => {
    addMessage("user", {
      content: value,
      buttons: [],
    });
    if (conversationType === "question") {
      setIsUserInputEnabled(false);
      createChatMessage({
        message: value,
        sessionId: sessionId,
        productArea: productArea,
      });
    }
  };

  return ({ event, value }) => {
    if (event === "select-conversation-type") {
      processSelectConversationType(value);
    } else if (event === "contact-support") {
      history.push("/form", { source: "chat", chatBotSessionId: sessionId });
    } else if (event === "start-chat") {
      addMessage("bot", buildChatPromptMessage());
      setSessionId(null);
      setProductArea(null);
      setConversationType(null);
      setIsUserInputEnabled(false);
      setIsConversationEnded(false);
    } else if (event === "restart-chat") {
      addMessage("bot", buildChatPromptMessage());
      setSessionId(null);
      setProductArea(null);
      setConversationType(null);
      setIsUserInputEnabled(false);
    } else if (event == "select-product-type") {
      if (conversationType === "question") {
        addMessage("bot", buildQuestionPrompt());
      }
      setProductArea(value);
      setIsUserInputEnabled(true);
    } else if (event == "post-message") {
      processPostMessage(value);
    } else if (event == "complete-chat") {
      addMessage("bot", {
        content: ["Enjoy the rest of your day!"],
        buttons: [],
      });
      setIsUserInputEnabled(false);
      setIsConversationEnded(true);
    }
  };
};
